import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/admin/company/:companyId/groups',
    name: 'adminGroups',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "admin-groups" */ './views/groups.vue')
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        handleRoute()
        function handleRoute() {
          const { companyId } = routeTo.params
          store.dispatch('adminGroups/setCompanyId', { companyId })
          store
            // fetch admin groups
            .dispatch('adminGroups/fetchLists', { companyId })
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'adminGroups' } })
            })
        }
      },
    },
  },
  {
    path: '/admin/company/:companyId/groups/add',
    name: 'adminGroupsAdd',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "admin-group-form" */
          './views/group-form.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/admin/company/:companyId/groups/edit/:groupId',
    name: 'adminGroupsEdit',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "admin-group-form" */
          './views/group-form.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      companyId: route.params.companyId,
      groupId: route.params.groupId,
    }),
  },
]
